import React from 'react';
import './App.css';
//import WipeAway from './WipeAway';
//import BidetWay from './BidetWay';
import Main from './Main';

/* updated to latest libraries on November 9, 2022 */

function App() {
  return (
    <Main />
	  /*<WipeAway />*/
    /*<BidetWay />*/
  )
}

export default App;
